__turbopack_context__.v({
  "eyeButton": "Login-module__DCxJyW__eyeButton",
  "loginContainer": "Login-module__DCxJyW__loginContainer",
  "loginPopup": "Login-module__DCxJyW__loginPopup",
  "message": "Login-module__DCxJyW__message",
  "passwordContainer": "Login-module__DCxJyW__passwordContainer",
  "subtitle": "Login-module__DCxJyW__subtitle",
});
